var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"grade-history"},[_c('table',[_vm._m(0),_c('tbody',_vm._l((_vm.histories),function(history){return _c('tr',{key:history.no},[_c('td',[_vm._v(_vm._s(history.no))]),_c('td',[_vm._v(_vm._s(history.courseName))]),_c('td',[_vm._v(_vm._s(history.lessonUnit))]),_c('td',[_c('b-button',{attrs:{"pill":"","variant":"secondary","to":{
              name:'StudentCourseGrades',
              params: {
                studentId: _vm.studentId,
                courseHistoryId: history.courseHistoryId
              }
            }}},[_vm._v(" Detail ")])],1)])}),0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('thead',[_c('tr',[_c('th',[_vm._v("No.")]),_c('th',[_vm._v("Course")]),_c('th',[_vm._v("Unit")]),_c('th',[_vm._v("Lesson")])])])
}]

export { render, staticRenderFns }